module.exports = __webpack_public_path__ + "img/logo-BirchEquipment-old.25b6ed7d.png";